import initCartApp from "./screens/cart/index";
initCartApp();
